import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { CatalogProductOption } from "./types";
import { TIER_CATALOG_PRODUCTS_QUERY_KEY } from "./constants";

interface ProductsEnvelope {
  readonly items: readonly CatalogProductOption[];
}

/**
 * Reads the existing `GET /api/admin/catalog/products` to populate the tier's
 * Stripe Product link picker and resolve a linked product's display name.
 * A local hook (not a catalog-feature import) — cross-feature imports are
 * banned; both slices simply call the same admin endpoint.
 */
async function fetchProducts(): Promise<readonly CatalogProductOption[]> {
  const res = await httpClient<ProductsEnvelope>("/api/admin/catalog/products");
  return res.items;
}

export function useCatalogProducts() {
  return useQuery({
    queryKey: TIER_CATALOG_PRODUCTS_QUERY_KEY,
    queryFn: fetchProducts,
    staleTime: 60_000,
  });
}
